import { createSceneReducer } from '../../reducers-util';
import quotesDataReducer from './quotes.data';
import quotesUiReducer from './quotes.ui';

export default createSceneReducer(quotesDataReducer, quotesUiReducer);
